import { useState } from "react";
import useFetch from "../../../../hooks/useFetch";
import { sortByKey } from "../../utils/string";

export default function useQuestionStatus() {
  const { request, loading } = useFetch();
  const [data, setData] = useState([]);

  const fetchData = async (url) => {
    const res = await request(url);
    if (res?.data) {
      const mapped = res.data.questionsAttemptStats.map((item) => ({
        Subject: item._id.name,
        Correct: item.correct,
        Incorrect: item.incorrect,
        Unattempted: item.unattempted,
      }));
      setData(sortByKey(mapped,"Subject"));
    }
  };

  return { data, loading, fetchData };
}